import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Configuration = {
  __typename?: 'Configuration';
  id: Scalars['ID']['output'];
  maxStorage: Scalars['Int']['output'];
  maxUsers: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Membership = {
  __typename?: 'Membership';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inviteEmail: Scalars['String']['output'];
  invitedAt?: Maybe<Scalars['String']['output']>;
  inviter: User;
  isOwner: Scalars['Boolean']['output'];
  role?: Maybe<MembershipRole>;
  state?: Maybe<MembershipState>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  workspace: Workspace;
};

export type MembershipInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inviteEmail: Scalars['String']['input'];
  invitedAt?: InputMaybe<Scalars['String']['input']>;
  inviterId: Scalars['ID']['input'];
  isOwner: Scalars['Boolean']['input'];
  role?: InputMaybe<MembershipRole>;
  state?: InputMaybe<MembershipState>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export enum MembershipRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export enum MembershipState {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type Mutation = {
  __typename?: 'Mutation';
  createMembership?: Maybe<Membership>;
  createSession?: Maybe<Session>;
  createUser?: Maybe<User>;
  createWorkspace?: Maybe<Workspace>;
  deleteMembership?: Maybe<Membership>;
  deleteSession?: Maybe<Session>;
  duplicateSession?: Maybe<Session>;
  unlockSession?: Maybe<Session>;
  updateMembership?: Maybe<Membership>;
  updateSession?: Maybe<Session>;
  updateUser?: Maybe<User>;
  updateWorkspaceStripeSubscriptionId?: Maybe<Workspace>;
};


export type MutationCreateMembershipArgs = {
  input: MembershipInput;
};


export type MutationCreateSessionArgs = {
  input: SessionInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateWorkspaceArgs = {
  input: WorkspaceInput;
};


export type MutationDeleteMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateSessionArgs = {
  destinationWorkspaceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnlockSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateMembershipArgs = {
  input: MembershipInput;
};


export type MutationUpdateSessionArgs = {
  input: SessionInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUpdateWorkspaceStripeSubscriptionIdArgs = {
  id: Scalars['ID']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  getMembership?: Maybe<Membership>;
  getUser?: Maybe<User>;
  getWorkspace?: Maybe<Workspace>;
  listConfigurations?: Maybe<Array<Maybe<Configuration>>>;
  listMemberships?: Maybe<Array<Maybe<Membership>>>;
  listMembershipsByWorkspace?: Maybe<Array<Maybe<Membership>>>;
  listSessionsByWorkspace?: Maybe<Array<Maybe<Session>>>;
  listSessionsByWorkspaceAndUser?: Maybe<Array<Maybe<Session>>>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  listWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
};


export type QueryGetMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListMembershipsByWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryListSessionsByWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryListSessionsByWorkspaceAndUserArgs = {
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryListUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryListWorkspacesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type Session = {
  __typename?: 'Session';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lockedAt?: Maybe<Scalars['String']['output']>;
  lockedBy?: Maybe<User>;
  mode: SessionMode;
  name: Scalars['String']['output'];
  reportUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  status: SessionStatus;
  type: SessionType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  workspace: Workspace;
};

export type SessionInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  lockedById?: InputMaybe<Scalars['ID']['input']>;
  mode: SessionMode;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  status: SessionStatus;
  type: SessionType;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export enum SessionMode {
  Jira = 'JIRA',
  Local = 'LOCAL',
  Xray = 'XRAY'
}

export enum SessionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SessionType {
  Charter = 'CHARTER',
  Session = 'SESSION'
}

export type Subscription = {
  __typename?: 'Subscription';
  onCreateMembership?: Maybe<Membership>;
  onCreateMembershipForWorkspace?: Maybe<Membership>;
  onCreateSessionForWorkspace?: Maybe<Session>;
  onDeleteMembership?: Maybe<Membership>;
  onDeleteMembershipForWorkspace?: Maybe<Membership>;
  onDeleteSessionForWorkspace?: Maybe<Session>;
  onUpdateMembership?: Maybe<Membership>;
  onUpdateMembershipForWorkspace?: Maybe<Membership>;
  onUpdateSessionForWorkspace?: Maybe<Session>;
  onUpdateUser?: Maybe<User>;
};


export type SubscriptionOnCreateMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOnCreateMembershipForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnCreateSessionForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnDeleteMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOnDeleteMembershipForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnDeleteSessionForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateMembershipForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateSessionForWorkspaceArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateUserArgs = {
  id: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  businessName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  invitations?: Maybe<Array<Maybe<Membership>>>;
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  memberships?: Maybe<Array<Maybe<Membership>>>;
  pendoDisabled?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Maybe<Session>>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionEndedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionPaymentMethod?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStartedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialEnd?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialEndedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialStartedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  businessName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pendoDisabled?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionEndedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionStartedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialEnd?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialEndedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialStartedAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  configuration?: Maybe<Configuration>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  memberships?: Maybe<Array<Maybe<Membership>>>;
  name: Scalars['String']['output'];
  scope?: Maybe<WorkspaceScope>;
  sessions?: Maybe<Array<Maybe<Session>>>;
  status?: Maybe<WorkspaceStatus>;
  stripeSubscriptionEndedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionPaymentMethod?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStartedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialEnd?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialEndedAt?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionTrialStartedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type WorkspaceInput = {
  configurationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  scope?: InputMaybe<WorkspaceScope>;
  status?: InputMaybe<WorkspaceStatus>;
  stripeSubscriptionEndedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionStartedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialEnd?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialEndedAt?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionTrialStartedAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum WorkspaceScope {
  Private = 'PRIVATE',
  Shared = 'SHARED'
}

export enum WorkspaceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ConfigurationFieldsFragment = { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number };

export type ListConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListConfigurationsQuery = { __typename?: 'Query', listConfigurations?: Array<{ __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null> | null };

export type MembershipFieldsFragment = { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null };

export type MembershipUserAndInviterFieldsFragment = { __typename?: 'Membership', inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type MembershipSubscriptionUserFieldsFragment = { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CreateMembershipMutationVariables = Exact<{
  input: MembershipInput;
}>;


export type CreateMembershipMutation = { __typename?: 'Mutation', createMembership?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, inviter: { __typename?: 'User', id?: string | null }, user?: { __typename?: 'User', id?: string | null } | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type UpdateMembershipMutationVariables = Exact<{
  input: MembershipInput;
}>;


export type UpdateMembershipMutation = { __typename?: 'Mutation', updateMembership?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, inviter: { __typename?: 'User', id?: string | null }, user?: { __typename?: 'User', id?: string | null } | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type DeleteMembershipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMembershipMutation = { __typename?: 'Mutation', deleteMembership?: { __typename?: 'Membership', id?: string | null, inviter: { __typename?: 'User', id?: string | null }, user?: { __typename?: 'User', id?: string | null } | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type ListMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMembershipsQuery = { __typename?: 'Query', listMemberships?: Array<{ __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, user?: { __typename?: 'User', id?: string | null } | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null } } | null> | null };

export type ListMembershipsByWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ListMembershipsByWorkspaceQuery = { __typename?: 'Query', listMembershipsByWorkspace?: Array<{ __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null> | null };

export type GetMembershipQueryVariables = Exact<{
  membershipId: Scalars['ID']['input'];
}>;


export type GetMembershipQuery = { __typename?: 'Query', getMembership?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null, memberships?: Array<{ __typename?: 'Membership', state?: MembershipState | null } | null> | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type OnCreateMembershipSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnCreateMembershipSubscription = { __typename?: 'Subscription', onCreateMembership?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type OnUpdateMembershipSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnUpdateMembershipSubscription = { __typename?: 'Subscription', onUpdateMembership?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type OnDeleteMembershipSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnDeleteMembershipSubscription = { __typename?: 'Subscription', onDeleteMembership?: { __typename?: 'Membership', id?: string | null, user?: { __typename?: 'User', id?: string | null } | null } | null };

export type OnCreateMembershipForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnCreateMembershipForWorkspaceSubscription = { __typename?: 'Subscription', onCreateMembershipForWorkspace?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type OnUpdateMembershipForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnUpdateMembershipForWorkspaceSubscription = { __typename?: 'Subscription', onUpdateMembershipForWorkspace?: { __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, workspace: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null }, inviter: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null }, user?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type OnDeleteMembershipForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnDeleteMembershipForWorkspaceSubscription = { __typename?: 'Subscription', onDeleteMembershipForWorkspace?: { __typename?: 'Membership', id?: string | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type SessionFieldsFragment = { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null };

export type CreateSessionMutationVariables = Exact<{
  input: SessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, lockedBy?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null, user: { __typename?: 'User', id?: string | null }, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type UpdateSessionMutationVariables = Exact<{
  input: SessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession?: { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null } | null };

export type DeleteSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSessionMutation = { __typename?: 'Mutation', deleteSession?: { __typename?: 'Session', id?: string | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type DuplicateSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  destinationWorkspaceId: Scalars['ID']['input'];
}>;


export type DuplicateSessionMutation = { __typename?: 'Mutation', duplicateSession?: { __typename?: 'Session', id?: string | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type UnlockSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockSessionMutation = { __typename?: 'Mutation', unlockSession?: { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null } | null };

export type ListSessionsByWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ListSessionsByWorkspaceQuery = { __typename?: 'Query', listSessionsByWorkspace?: Array<{ __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, lockedBy?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string } | null, user: { __typename?: 'User', id?: string | null }, workspace: { __typename?: 'Workspace', id?: string | null } } | null> | null };

export type ListSessionsByWorkspaceAndUserQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type ListSessionsByWorkspaceAndUserQuery = { __typename?: 'Query', listSessionsByWorkspaceAndUser?: Array<{ __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null } | null> | null };

export type OnCreateSessionForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnCreateSessionForWorkspaceSubscription = { __typename?: 'Subscription', onCreateSessionForWorkspace?: { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, user: { __typename?: 'User', id?: string | null }, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type OnUpdateSessionForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnUpdateSessionForWorkspaceSubscription = { __typename?: 'Subscription', onUpdateSessionForWorkspace?: { __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, user: { __typename?: 'User', id?: string | null }, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type OnDeleteSessionForWorkspaceSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type OnDeleteSessionForWorkspaceSubscription = { __typename?: 'Subscription', onDeleteSessionForWorkspace?: { __typename?: 'Session', id?: string | null, workspace: { __typename?: 'Workspace', id?: string | null } } | null };

export type UserFieldsFragment = { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null };

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type ListUsersQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers?: Array<{ __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type OnUpdateUserSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnUpdateUserSubscription = { __typename?: 'Subscription', onUpdateUser?: { __typename?: 'User', id?: string | null, firstName: string, lastName: string, jobTitle: string, country: string, businessName: string, email: string, pendoDisabled?: string | null, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type WorkspaceFieldsFragment = { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null };

export type WorkspaceConfigurationFieldsFragment = { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null, memberships?: Array<{ __typename?: 'Membership', state?: MembershipState | null } | null> | null };

export type WorkspaceResponseFieldsFragment = { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, memberships?: Array<{ __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, user?: { __typename?: 'User', id?: string | null } | null } | null> | null, sessions?: Array<{ __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, user: { __typename?: 'User', id?: string | null } } | null> | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null };

export type CreateWorkspaceMutationVariables = Exact<{
  input: WorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace?: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null } | null };

export type UpdateWorkspaceStripeSubscriptionIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpdateWorkspaceStripeSubscriptionIdMutation = { __typename?: 'Mutation', updateWorkspaceStripeSubscriptionId?: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null } | null };

export type GetWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceQuery = { __typename?: 'Query', getWorkspace?: { __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, memberships?: Array<{ __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, user?: { __typename?: 'User', id?: string | null } | null } | null> | null, sessions?: Array<{ __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, user: { __typename?: 'User', id?: string | null } } | null> | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null } | null };

export type ListWorkspacesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListWorkspacesQuery = { __typename?: 'Query', listWorkspaces?: Array<{ __typename?: 'Workspace', id?: string | null, name: string, url: string, description?: string | null, scope?: WorkspaceScope | null, status?: WorkspaceStatus | null, stripeSubscriptionId?: string | null, stripeSubscriptionStatus?: string | null, stripeSubscriptionPaymentMethod?: string | null, stripeSubscriptionStartedAt?: string | null, stripeSubscriptionEndedAt?: string | null, stripeSubscriptionTrialEnd?: string | null, stripeSubscriptionTrialStartedAt?: string | null, stripeSubscriptionTrialEndedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, expiresAt?: string | null, memberships?: Array<{ __typename?: 'Membership', id?: string | null, isOwner: boolean, role?: MembershipRole | null, state?: MembershipState | null, invitedAt?: string | null, inviteEmail: string, createdAt?: string | null, updatedAt?: string | null, user?: { __typename?: 'User', id?: string | null } | null } | null> | null, sessions?: Array<{ __typename?: 'Session', id?: string | null, name: string, description?: string | null, status: SessionStatus, mode: SessionMode, domain?: string | null, type: SessionType, size?: string | null, createdAt?: string | null, updatedAt?: string | null, lockedAt?: string | null, reportUrl?: string | null, user: { __typename?: 'User', id?: string | null } } | null> | null, configuration?: { __typename?: 'Configuration', id: string, name: string, maxStorage: number, maxUsers: number } | null } | null> | null };

export const MembershipFieldsFragmentDoc = gql`
    fragment MembershipFields on Membership {
  id
  isOwner
  role
  state
  invitedAt
  inviteEmail
  createdAt
  updatedAt
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  jobTitle
  country
  businessName
  email
  pendoDisabled
  stripeCustomerId
  stripeSubscriptionId
  stripeSubscriptionStatus
  stripeSubscriptionPaymentMethod
  stripeSubscriptionStartedAt
  stripeSubscriptionEndedAt
  stripeSubscriptionTrialEnd
  stripeSubscriptionTrialStartedAt
  stripeSubscriptionTrialEndedAt
  createdAt
  updatedAt
}
    `;
export const MembershipUserAndInviterFieldsFragmentDoc = gql`
    fragment MembershipUserAndInviterFields on Membership {
  inviter {
    ...UserFields
  }
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const WorkspaceFieldsFragmentDoc = gql`
    fragment WorkspaceFields on Workspace {
  id
  name
  url
  description
  scope
  status
  stripeSubscriptionId
  stripeSubscriptionStatus
  stripeSubscriptionPaymentMethod
  stripeSubscriptionStartedAt
  stripeSubscriptionEndedAt
  stripeSubscriptionTrialEnd
  stripeSubscriptionTrialStartedAt
  stripeSubscriptionTrialEndedAt
  createdAt
  updatedAt
  expiresAt
}
    `;
export const ConfigurationFieldsFragmentDoc = gql`
    fragment ConfigurationFields on Configuration {
  id
  name
  maxStorage
  maxUsers
}
    `;
export const MembershipSubscriptionUserFieldsFragmentDoc = gql`
    fragment MembershipSubscriptionUserFields on Membership {
  ...MembershipFields
  ...MembershipUserAndInviterFields
  workspace {
    ...WorkspaceFields
    configuration {
      ...ConfigurationFields
    }
  }
}
    ${MembershipFieldsFragmentDoc}
${MembershipUserAndInviterFieldsFragmentDoc}
${WorkspaceFieldsFragmentDoc}
${ConfigurationFieldsFragmentDoc}`;
export const WorkspaceConfigurationFieldsFragmentDoc = gql`
    fragment WorkspaceConfigurationFields on Workspace {
  ...WorkspaceFields
  configuration {
    ...ConfigurationFields
  }
  memberships {
    state
  }
}
    ${WorkspaceFieldsFragmentDoc}
${ConfigurationFieldsFragmentDoc}`;
export const SessionFieldsFragmentDoc = gql`
    fragment SessionFields on Session {
  id
  name
  description
  status
  mode
  domain
  type
  size
  createdAt
  updatedAt
  lockedAt
  reportUrl
}
    `;
export const WorkspaceResponseFieldsFragmentDoc = gql`
    fragment WorkspaceResponseFields on Workspace {
  ...WorkspaceFields
  memberships {
    ...MembershipFields
    user {
      id
    }
  }
  sessions {
    ...SessionFields
    user {
      id
    }
  }
  configuration {
    ...ConfigurationFields
  }
}
    ${WorkspaceFieldsFragmentDoc}
${MembershipFieldsFragmentDoc}
${SessionFieldsFragmentDoc}
${ConfigurationFieldsFragmentDoc}`;
export const ListConfigurationsDocument = gql`
    query listConfigurations {
  listConfigurations {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;

/**
 * __useListConfigurationsQuery__
 *
 * To run a query within a React component, call `useListConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<ListConfigurationsQuery, ListConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConfigurationsQuery, ListConfigurationsQueryVariables>(ListConfigurationsDocument, options);
      }
export function useListConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConfigurationsQuery, ListConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConfigurationsQuery, ListConfigurationsQueryVariables>(ListConfigurationsDocument, options);
        }
export function useListConfigurationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListConfigurationsQuery, ListConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConfigurationsQuery, ListConfigurationsQueryVariables>(ListConfigurationsDocument, options);
        }
export type ListConfigurationsQueryHookResult = ReturnType<typeof useListConfigurationsQuery>;
export type ListConfigurationsLazyQueryHookResult = ReturnType<typeof useListConfigurationsLazyQuery>;
export type ListConfigurationsSuspenseQueryHookResult = ReturnType<typeof useListConfigurationsSuspenseQuery>;
export type ListConfigurationsQueryResult = Apollo.QueryResult<ListConfigurationsQuery, ListConfigurationsQueryVariables>;
export const CreateMembershipDocument = gql`
    mutation createMembership($input: MembershipInput!) {
  createMembership(input: $input) {
    ...MembershipFields
    inviter {
      id
    }
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${MembershipFieldsFragmentDoc}`;
export type CreateMembershipMutationFn = Apollo.MutationFunction<CreateMembershipMutation, CreateMembershipMutationVariables>;

/**
 * __useCreateMembershipMutation__
 *
 * To run a mutation, you first call `useCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipMutation, { data, loading, error }] = useCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateMembershipMutation, CreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMembershipMutation, CreateMembershipMutationVariables>(CreateMembershipDocument, options);
      }
export type CreateMembershipMutationHookResult = ReturnType<typeof useCreateMembershipMutation>;
export type CreateMembershipMutationResult = Apollo.MutationResult<CreateMembershipMutation>;
export type CreateMembershipMutationOptions = Apollo.BaseMutationOptions<CreateMembershipMutation, CreateMembershipMutationVariables>;
export const UpdateMembershipDocument = gql`
    mutation updateMembership($input: MembershipInput!) {
  updateMembership(input: $input) {
    ...MembershipFields
    inviter {
      id
    }
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${MembershipFieldsFragmentDoc}`;
export type UpdateMembershipMutationFn = Apollo.MutationFunction<UpdateMembershipMutation, UpdateMembershipMutationVariables>;

/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMembershipMutation, UpdateMembershipMutationVariables>(UpdateMembershipDocument, options);
      }
export type UpdateMembershipMutationHookResult = ReturnType<typeof useUpdateMembershipMutation>;
export type UpdateMembershipMutationResult = Apollo.MutationResult<UpdateMembershipMutation>;
export type UpdateMembershipMutationOptions = Apollo.BaseMutationOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>;
export const DeleteMembershipDocument = gql`
    mutation deleteMembership($id: ID!) {
  deleteMembership(id: $id) {
    id
    inviter {
      id
    }
    user {
      id
    }
    workspace {
      id
    }
  }
}
    `;
export type DeleteMembershipMutationFn = Apollo.MutationFunction<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMembershipMutation, DeleteMembershipMutationVariables>(DeleteMembershipDocument, options);
      }
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<DeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>;
export const ListMembershipsDocument = gql`
    query listMemberships {
  listMemberships {
    ...MembershipFields
    user {
      id
    }
    workspace {
      ...WorkspaceFields
      configuration {
        ...ConfigurationFields
      }
    }
  }
}
    ${MembershipFieldsFragmentDoc}
${WorkspaceFieldsFragmentDoc}
${ConfigurationFieldsFragmentDoc}`;

/**
 * __useListMembershipsQuery__
 *
 * To run a query within a React component, call `useListMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<ListMembershipsQuery, ListMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembershipsQuery, ListMembershipsQueryVariables>(ListMembershipsDocument, options);
      }
export function useListMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembershipsQuery, ListMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembershipsQuery, ListMembershipsQueryVariables>(ListMembershipsDocument, options);
        }
export function useListMembershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMembershipsQuery, ListMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMembershipsQuery, ListMembershipsQueryVariables>(ListMembershipsDocument, options);
        }
export type ListMembershipsQueryHookResult = ReturnType<typeof useListMembershipsQuery>;
export type ListMembershipsLazyQueryHookResult = ReturnType<typeof useListMembershipsLazyQuery>;
export type ListMembershipsSuspenseQueryHookResult = ReturnType<typeof useListMembershipsSuspenseQuery>;
export type ListMembershipsQueryResult = Apollo.QueryResult<ListMembershipsQuery, ListMembershipsQueryVariables>;
export const ListMembershipsByWorkspaceDocument = gql`
    query listMembershipsByWorkspace($workspaceId: ID!) {
  listMembershipsByWorkspace(workspaceId: $workspaceId) {
    ...MembershipFields
    ...MembershipUserAndInviterFields
    workspace {
      id
    }
  }
}
    ${MembershipFieldsFragmentDoc}
${MembershipUserAndInviterFieldsFragmentDoc}`;

/**
 * __useListMembershipsByWorkspaceQuery__
 *
 * To run a query within a React component, call `useListMembershipsByWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMembershipsByWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMembershipsByWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useListMembershipsByWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>(ListMembershipsByWorkspaceDocument, options);
      }
export function useListMembershipsByWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>(ListMembershipsByWorkspaceDocument, options);
        }
export function useListMembershipsByWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>(ListMembershipsByWorkspaceDocument, options);
        }
export type ListMembershipsByWorkspaceQueryHookResult = ReturnType<typeof useListMembershipsByWorkspaceQuery>;
export type ListMembershipsByWorkspaceLazyQueryHookResult = ReturnType<typeof useListMembershipsByWorkspaceLazyQuery>;
export type ListMembershipsByWorkspaceSuspenseQueryHookResult = ReturnType<typeof useListMembershipsByWorkspaceSuspenseQuery>;
export type ListMembershipsByWorkspaceQueryResult = Apollo.QueryResult<ListMembershipsByWorkspaceQuery, ListMembershipsByWorkspaceQueryVariables>;
export const GetMembershipDocument = gql`
    query getMembership($membershipId: ID!) {
  getMembership(membershipId: $membershipId) {
    ...MembershipFields
    ...MembershipUserAndInviterFields
    workspace {
      ...WorkspaceConfigurationFields
    }
  }
}
    ${MembershipFieldsFragmentDoc}
${MembershipUserAndInviterFieldsFragmentDoc}
${WorkspaceConfigurationFieldsFragmentDoc}`;

/**
 * __useGetMembershipQuery__
 *
 * To run a query within a React component, call `useGetMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useGetMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
      }
export function useGetMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
        }
export function useGetMembershipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
        }
export type GetMembershipQueryHookResult = ReturnType<typeof useGetMembershipQuery>;
export type GetMembershipLazyQueryHookResult = ReturnType<typeof useGetMembershipLazyQuery>;
export type GetMembershipSuspenseQueryHookResult = ReturnType<typeof useGetMembershipSuspenseQuery>;
export type GetMembershipQueryResult = Apollo.QueryResult<GetMembershipQuery, GetMembershipQueryVariables>;
export const OnCreateMembershipDocument = gql`
    subscription onCreateMembership($id: ID!) {
  onCreateMembership(id: $id) {
    ...MembershipSubscriptionUserFields
  }
}
    ${MembershipSubscriptionUserFieldsFragmentDoc}`;

/**
 * __useOnCreateMembershipSubscription__
 *
 * To run a query within a React component, call `useOnCreateMembershipSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMembershipSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMembershipSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnCreateMembershipSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCreateMembershipSubscription, OnCreateMembershipSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMembershipSubscription, OnCreateMembershipSubscriptionVariables>(OnCreateMembershipDocument, options);
      }
export type OnCreateMembershipSubscriptionHookResult = ReturnType<typeof useOnCreateMembershipSubscription>;
export type OnCreateMembershipSubscriptionResult = Apollo.SubscriptionResult<OnCreateMembershipSubscription>;
export const OnUpdateMembershipDocument = gql`
    subscription onUpdateMembership($id: ID!) {
  onUpdateMembership(id: $id) {
    ...MembershipSubscriptionUserFields
  }
}
    ${MembershipSubscriptionUserFieldsFragmentDoc}`;

/**
 * __useOnUpdateMembershipSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMembershipSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMembershipSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMembershipSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnUpdateMembershipSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnUpdateMembershipSubscription, OnUpdateMembershipSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMembershipSubscription, OnUpdateMembershipSubscriptionVariables>(OnUpdateMembershipDocument, options);
      }
export type OnUpdateMembershipSubscriptionHookResult = ReturnType<typeof useOnUpdateMembershipSubscription>;
export type OnUpdateMembershipSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMembershipSubscription>;
export const OnDeleteMembershipDocument = gql`
    subscription onDeleteMembership($id: ID!) {
  onDeleteMembership(id: $id) {
    id
    user {
      id
    }
  }
}
    `;

/**
 * __useOnDeleteMembershipSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMembershipSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMembershipSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMembershipSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnDeleteMembershipSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDeleteMembershipSubscription, OnDeleteMembershipSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMembershipSubscription, OnDeleteMembershipSubscriptionVariables>(OnDeleteMembershipDocument, options);
      }
export type OnDeleteMembershipSubscriptionHookResult = ReturnType<typeof useOnDeleteMembershipSubscription>;
export type OnDeleteMembershipSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMembershipSubscription>;
export const OnCreateMembershipForWorkspaceDocument = gql`
    subscription onCreateMembershipForWorkspace($workspaceId: ID!) {
  onCreateMembershipForWorkspace(workspaceId: $workspaceId) {
    ...MembershipSubscriptionUserFields
  }
}
    ${MembershipSubscriptionUserFieldsFragmentDoc}`;

/**
 * __useOnCreateMembershipForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnCreateMembershipForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateMembershipForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateMembershipForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnCreateMembershipForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCreateMembershipForWorkspaceSubscription, OnCreateMembershipForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateMembershipForWorkspaceSubscription, OnCreateMembershipForWorkspaceSubscriptionVariables>(OnCreateMembershipForWorkspaceDocument, options);
      }
export type OnCreateMembershipForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnCreateMembershipForWorkspaceSubscription>;
export type OnCreateMembershipForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnCreateMembershipForWorkspaceSubscription>;
export const OnUpdateMembershipForWorkspaceDocument = gql`
    subscription onUpdateMembershipForWorkspace($workspaceId: ID!) {
  onUpdateMembershipForWorkspace(workspaceId: $workspaceId) {
    ...MembershipSubscriptionUserFields
  }
}
    ${MembershipSubscriptionUserFieldsFragmentDoc}`;

/**
 * __useOnUpdateMembershipForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMembershipForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMembershipForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMembershipForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnUpdateMembershipForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnUpdateMembershipForWorkspaceSubscription, OnUpdateMembershipForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateMembershipForWorkspaceSubscription, OnUpdateMembershipForWorkspaceSubscriptionVariables>(OnUpdateMembershipForWorkspaceDocument, options);
      }
export type OnUpdateMembershipForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnUpdateMembershipForWorkspaceSubscription>;
export type OnUpdateMembershipForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnUpdateMembershipForWorkspaceSubscription>;
export const OnDeleteMembershipForWorkspaceDocument = gql`
    subscription onDeleteMembershipForWorkspace($workspaceId: ID!) {
  onDeleteMembershipForWorkspace(workspaceId: $workspaceId) {
    id
    workspace {
      id
    }
  }
}
    `;

/**
 * __useOnDeleteMembershipForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnDeleteMembershipForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteMembershipForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteMembershipForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnDeleteMembershipForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDeleteMembershipForWorkspaceSubscription, OnDeleteMembershipForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteMembershipForWorkspaceSubscription, OnDeleteMembershipForWorkspaceSubscriptionVariables>(OnDeleteMembershipForWorkspaceDocument, options);
      }
export type OnDeleteMembershipForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnDeleteMembershipForWorkspaceSubscription>;
export type OnDeleteMembershipForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnDeleteMembershipForWorkspaceSubscription>;
export const CreateSessionDocument = gql`
    mutation createSession($input: SessionInput!) {
  createSession(input: $input) {
    ...SessionFields
    lockedBy {
      ...UserFields
    }
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${SessionFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($input: SessionInput!) {
  updateSession(input: $input) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const DeleteSessionDocument = gql`
    mutation deleteSession($id: ID!) {
  deleteSession(id: $id) {
    id
    workspace {
      id
    }
  }
}
    `;
export type DeleteSessionMutationFn = Apollo.MutationFunction<DeleteSessionMutation, DeleteSessionMutationVariables>;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSessionMutation, DeleteSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSessionMutation, DeleteSessionMutationVariables>(DeleteSessionDocument, options);
      }
export type DeleteSessionMutationHookResult = ReturnType<typeof useDeleteSessionMutation>;
export type DeleteSessionMutationResult = Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<DeleteSessionMutation, DeleteSessionMutationVariables>;
export const DuplicateSessionDocument = gql`
    mutation duplicateSession($id: ID!, $name: String, $destinationWorkspaceId: ID!) {
  duplicateSession(
    id: $id
    name: $name
    destinationWorkspaceId: $destinationWorkspaceId
  ) {
    id
    workspace {
      id
    }
  }
}
    `;
export type DuplicateSessionMutationFn = Apollo.MutationFunction<DuplicateSessionMutation, DuplicateSessionMutationVariables>;

/**
 * __useDuplicateSessionMutation__
 *
 * To run a mutation, you first call `useDuplicateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateSessionMutation, { data, loading, error }] = useDuplicateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      destinationWorkspaceId: // value for 'destinationWorkspaceId'
 *   },
 * });
 */
export function useDuplicateSessionMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateSessionMutation, DuplicateSessionMutationVariables>(DuplicateSessionDocument, options);
      }
export type DuplicateSessionMutationHookResult = ReturnType<typeof useDuplicateSessionMutation>;
export type DuplicateSessionMutationResult = Apollo.MutationResult<DuplicateSessionMutation>;
export type DuplicateSessionMutationOptions = Apollo.BaseMutationOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>;
export const UnlockSessionDocument = gql`
    mutation unlockSession($id: ID!) {
  unlockSession(id: $id) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type UnlockSessionMutationFn = Apollo.MutationFunction<UnlockSessionMutation, UnlockSessionMutationVariables>;

/**
 * __useUnlockSessionMutation__
 *
 * To run a mutation, you first call `useUnlockSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockSessionMutation, { data, loading, error }] = useUnlockSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockSessionMutation(baseOptions?: Apollo.MutationHookOptions<UnlockSessionMutation, UnlockSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockSessionMutation, UnlockSessionMutationVariables>(UnlockSessionDocument, options);
      }
export type UnlockSessionMutationHookResult = ReturnType<typeof useUnlockSessionMutation>;
export type UnlockSessionMutationResult = Apollo.MutationResult<UnlockSessionMutation>;
export type UnlockSessionMutationOptions = Apollo.BaseMutationOptions<UnlockSessionMutation, UnlockSessionMutationVariables>;
export const ListSessionsByWorkspaceDocument = gql`
    query listSessionsByWorkspace($workspaceId: ID!) {
  listSessionsByWorkspace(workspaceId: $workspaceId) {
    ...SessionFields
    lockedBy {
      id
      firstName
      lastName
    }
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${SessionFieldsFragmentDoc}`;

/**
 * __useListSessionsByWorkspaceQuery__
 *
 * To run a query within a React component, call `useListSessionsByWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSessionsByWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSessionsByWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useListSessionsByWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>(ListSessionsByWorkspaceDocument, options);
      }
export function useListSessionsByWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>(ListSessionsByWorkspaceDocument, options);
        }
export function useListSessionsByWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>(ListSessionsByWorkspaceDocument, options);
        }
export type ListSessionsByWorkspaceQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceQuery>;
export type ListSessionsByWorkspaceLazyQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceLazyQuery>;
export type ListSessionsByWorkspaceSuspenseQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceSuspenseQuery>;
export type ListSessionsByWorkspaceQueryResult = Apollo.QueryResult<ListSessionsByWorkspaceQuery, ListSessionsByWorkspaceQueryVariables>;
export const ListSessionsByWorkspaceAndUserDocument = gql`
    query listSessionsByWorkspaceAndUser($workspaceId: ID!, $userId: ID!) {
  listSessionsByWorkspaceAndUser(workspaceId: $workspaceId, userId: $userId) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;

/**
 * __useListSessionsByWorkspaceAndUserQuery__
 *
 * To run a query within a React component, call `useListSessionsByWorkspaceAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSessionsByWorkspaceAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSessionsByWorkspaceAndUserQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListSessionsByWorkspaceAndUserQuery(baseOptions: Apollo.QueryHookOptions<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>(ListSessionsByWorkspaceAndUserDocument, options);
      }
export function useListSessionsByWorkspaceAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>(ListSessionsByWorkspaceAndUserDocument, options);
        }
export function useListSessionsByWorkspaceAndUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>(ListSessionsByWorkspaceAndUserDocument, options);
        }
export type ListSessionsByWorkspaceAndUserQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceAndUserQuery>;
export type ListSessionsByWorkspaceAndUserLazyQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceAndUserLazyQuery>;
export type ListSessionsByWorkspaceAndUserSuspenseQueryHookResult = ReturnType<typeof useListSessionsByWorkspaceAndUserSuspenseQuery>;
export type ListSessionsByWorkspaceAndUserQueryResult = Apollo.QueryResult<ListSessionsByWorkspaceAndUserQuery, ListSessionsByWorkspaceAndUserQueryVariables>;
export const OnCreateSessionForWorkspaceDocument = gql`
    subscription onCreateSessionForWorkspace($workspaceId: ID!) {
  onCreateSessionForWorkspace(workspaceId: $workspaceId) {
    ...SessionFields
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${SessionFieldsFragmentDoc}`;

/**
 * __useOnCreateSessionForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnCreateSessionForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateSessionForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateSessionForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnCreateSessionForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCreateSessionForWorkspaceSubscription, OnCreateSessionForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateSessionForWorkspaceSubscription, OnCreateSessionForWorkspaceSubscriptionVariables>(OnCreateSessionForWorkspaceDocument, options);
      }
export type OnCreateSessionForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnCreateSessionForWorkspaceSubscription>;
export type OnCreateSessionForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnCreateSessionForWorkspaceSubscription>;
export const OnUpdateSessionForWorkspaceDocument = gql`
    subscription onUpdateSessionForWorkspace($workspaceId: ID!) {
  onUpdateSessionForWorkspace(workspaceId: $workspaceId) {
    ...SessionFields
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${SessionFieldsFragmentDoc}`;

/**
 * __useOnUpdateSessionForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnUpdateSessionForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateSessionForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateSessionForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnUpdateSessionForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnUpdateSessionForWorkspaceSubscription, OnUpdateSessionForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateSessionForWorkspaceSubscription, OnUpdateSessionForWorkspaceSubscriptionVariables>(OnUpdateSessionForWorkspaceDocument, options);
      }
export type OnUpdateSessionForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnUpdateSessionForWorkspaceSubscription>;
export type OnUpdateSessionForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnUpdateSessionForWorkspaceSubscription>;
export const OnDeleteSessionForWorkspaceDocument = gql`
    subscription onDeleteSessionForWorkspace($workspaceId: ID!) {
  onDeleteSessionForWorkspace(workspaceId: $workspaceId) {
    id
    workspace {
      id
    }
  }
}
    `;

/**
 * __useOnDeleteSessionForWorkspaceSubscription__
 *
 * To run a query within a React component, call `useOnDeleteSessionForWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDeleteSessionForWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDeleteSessionForWorkspaceSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnDeleteSessionForWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDeleteSessionForWorkspaceSubscription, OnDeleteSessionForWorkspaceSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDeleteSessionForWorkspaceSubscription, OnDeleteSessionForWorkspaceSubscriptionVariables>(OnDeleteSessionForWorkspaceDocument, options);
      }
export type OnDeleteSessionForWorkspaceSubscriptionHookResult = ReturnType<typeof useOnDeleteSessionForWorkspaceSubscription>;
export type OnDeleteSessionForWorkspaceSubscriptionResult = Apollo.SubscriptionResult<OnDeleteSessionForWorkspaceSubscription>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserInput!) {
  createUser(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ListUsersDocument = gql`
    query listUsers($ids: [ID!]!) {
  listUsers(ids: $ids) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  getUser(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const OnUpdateUserDocument = gql`
    subscription onUpdateUser($id: ID!) {
  onUpdateUser(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useOnUpdateUserSubscription__
 *
 * To run a query within a React component, call `useOnUpdateUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateUserSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnUpdateUserSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnUpdateUserSubscription, OnUpdateUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnUpdateUserSubscription, OnUpdateUserSubscriptionVariables>(OnUpdateUserDocument, options);
      }
export type OnUpdateUserSubscriptionHookResult = ReturnType<typeof useOnUpdateUserSubscription>;
export type OnUpdateUserSubscriptionResult = Apollo.SubscriptionResult<OnUpdateUserSubscription>;
export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($input: WorkspaceInput!) {
  createWorkspace(input: $input) {
    ...WorkspaceFields
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const UpdateWorkspaceStripeSubscriptionIdDocument = gql`
    mutation updateWorkspaceStripeSubscriptionId($id: ID!, $subscriptionId: String!) {
  updateWorkspaceStripeSubscriptionId(id: $id, subscriptionId: $subscriptionId) {
    ...WorkspaceFields
  }
}
    ${WorkspaceFieldsFragmentDoc}`;
export type UpdateWorkspaceStripeSubscriptionIdMutationFn = Apollo.MutationFunction<UpdateWorkspaceStripeSubscriptionIdMutation, UpdateWorkspaceStripeSubscriptionIdMutationVariables>;

/**
 * __useUpdateWorkspaceStripeSubscriptionIdMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceStripeSubscriptionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceStripeSubscriptionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceStripeSubscriptionIdMutation, { data, loading, error }] = useUpdateWorkspaceStripeSubscriptionIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpdateWorkspaceStripeSubscriptionIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceStripeSubscriptionIdMutation, UpdateWorkspaceStripeSubscriptionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceStripeSubscriptionIdMutation, UpdateWorkspaceStripeSubscriptionIdMutationVariables>(UpdateWorkspaceStripeSubscriptionIdDocument, options);
      }
export type UpdateWorkspaceStripeSubscriptionIdMutationHookResult = ReturnType<typeof useUpdateWorkspaceStripeSubscriptionIdMutation>;
export type UpdateWorkspaceStripeSubscriptionIdMutationResult = Apollo.MutationResult<UpdateWorkspaceStripeSubscriptionIdMutation>;
export type UpdateWorkspaceStripeSubscriptionIdMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceStripeSubscriptionIdMutation, UpdateWorkspaceStripeSubscriptionIdMutationVariables>;
export const GetWorkspaceDocument = gql`
    query getWorkspace($id: ID!) {
  getWorkspace(id: $id) {
    ...WorkspaceResponseFields
  }
}
    ${WorkspaceResponseFieldsFragmentDoc}`;

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
      }
export function useGetWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
        }
export function useGetWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
        }
export type GetWorkspaceQueryHookResult = ReturnType<typeof useGetWorkspaceQuery>;
export type GetWorkspaceLazyQueryHookResult = ReturnType<typeof useGetWorkspaceLazyQuery>;
export type GetWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSuspenseQuery>;
export type GetWorkspaceQueryResult = Apollo.QueryResult<GetWorkspaceQuery, GetWorkspaceQueryVariables>;
export const ListWorkspacesDocument = gql`
    query listWorkspaces($ids: [ID!]!) {
  listWorkspaces(ids: $ids) {
    ...WorkspaceResponseFields
  }
}
    ${WorkspaceResponseFieldsFragmentDoc}`;

/**
 * __useListWorkspacesQuery__
 *
 * To run a query within a React component, call `useListWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkspacesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListWorkspacesQuery(baseOptions: Apollo.QueryHookOptions<ListWorkspacesQuery, ListWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkspacesQuery, ListWorkspacesQueryVariables>(ListWorkspacesDocument, options);
      }
export function useListWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkspacesQuery, ListWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkspacesQuery, ListWorkspacesQueryVariables>(ListWorkspacesDocument, options);
        }
export function useListWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkspacesQuery, ListWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkspacesQuery, ListWorkspacesQueryVariables>(ListWorkspacesDocument, options);
        }
export type ListWorkspacesQueryHookResult = ReturnType<typeof useListWorkspacesQuery>;
export type ListWorkspacesLazyQueryHookResult = ReturnType<typeof useListWorkspacesLazyQuery>;
export type ListWorkspacesSuspenseQueryHookResult = ReturnType<typeof useListWorkspacesSuspenseQuery>;
export type ListWorkspacesQueryResult = Apollo.QueryResult<ListWorkspacesQuery, ListWorkspacesQueryVariables>;